import { render, staticRenderFns } from "./AddOrganization.vue?vue&type=template&id=65819f52&scoped=true&"
import script from "./AddOrganization.vue?vue&type=script&lang=js&"
export * from "./AddOrganization.vue?vue&type=script&lang=js&"
import style0 from "./AddOrganization.vue?vue&type=style&index=0&id=65819f52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65819f52",
  null
  
)

export default component.exports